import { get, patch, post } from "../../utils/request";

export const postOrders = async (orders) => {
  const res = await post(`orders`, orders);
  return res;
};

export const updateProductStock = async (productId, stock = false) => {
  const products = await get(`products?idProducts=${productId}`);
  if (!products || products.length === 0) return;

  const product = products[0];
  const res = await patch(`products/${product.id}`, { stock });
  return res;
};

export const patchStockProduct = async (
  key,
  productId,
  newStockValue = false
) => {
  // Lấy header theo key
  const headerRes = await get(`headers-products?key=${key}`);
  if (!headerRes || headerRes.length === 0) {
    throw new Error("Header không tồn tại hoặc sai key");
  }

  const header = headerRes[0];

  // Tạo danh sách product mới với stock cập nhật
  const updatedProducts = header.products.map((product) =>
    product.idProducts === productId
      ? { ...product, stock: newStockValue }
      : product
  );

  // PATCH chỉ field products
  const res = await patch(`headers-products/${header.id}`, {
    products: updatedProducts,
  });

  return res;
};
